import "./MyLearningOptions.scss";

import Button from "components/Buttons/Button";
import React from "react";
import { useIntl } from "react-intl";

interface LearningOption {
    id?: number;
    icon?: React.ReactElement<any>;
    title?: string;
    description: string;
    link: string;
    buttonLabel: string;
}

export const learningOptions: LearningOption[] = [
    {
        id: 1,
        title: "WeLearn",
        description:
            "WeLearn is our Learning Management System (LMS). Here you can find all the formal training programmes and courses available at Wärtsilä. Through this system you can enroll yourself, find your training history, and see the calendar for the upcoming trainings. ",
        link: "https://wartsila.sabacloud.com/Saba/Web_spf/EU2PRD0050/app/dashboard",
        buttonLabel: "Go to WeLearn",
    },
    {
        id: 2,
        title: "Learn & Grow",
        description:
            "Learn & Grow is the Compass site where you can find the latest news on learning and development. Through the site you can find links to articles, learning paths in WeLeap, WeLearn workspaces, and communities, such as the Wärtsilä Leader Community and the Mentoring and Coaching Community",
        link: "https://wartsila.sharepoint.com/sites/INT-Learning",
        buttonLabel: "Go to Compass",
    },
];

const LearningOption = ({ icon, title, description, buttonLabel, link }: LearningOption) => {
    return (
        <div className="option-box">
            <div className="option-content">
                {icon ? (
                    <div className="option-content__icon">{icon}</div>
                ) : (
                    <div className="option-content__title">{title}</div>
                )}
                <div className="option-content__description">{description}</div>
                <div className="option-content__button">
                    <Button to={link} text={buttonLabel} variant="secondary" size="small" />
                </div>
            </div>
        </div>
    );
};

const MyLearningOptions = () => {
    const intl = useIntl();
    return (
        <div className="myLearning-options">
            <div className="myLearning-options__title">
                {intl.formatMessage({
                    id: "my_learning.options.title",
                })}
            </div>
            <div className="myLearning-options__description">
                {intl.formatMessage({
                    id: "my_learning.options.description_1",
                })}
            </div>
            <div className="myLearning-options__description_2">
                {intl.formatMessage({
                    id: "my_learning.options.description_2",
                })}
            </div>
            <div className="learning-options-container">
                {learningOptions.map((option) => {
                    return (
                        <div key={option.id} className="learning-options-container__item">
                            <LearningOption
                                description={option.description}
                                buttonLabel={option.buttonLabel}
                                link={option.link}
                                title={option.title}
                                icon={option.icon}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default MyLearningOptions;
